import { Divider, Skeleton } from '@mantine/core'

export function NavBarSkeleton() {
	return (
		<nav className="flex overflow-visible overflow-y-auto flex-col h-full min-h-0 bg-surface-default">
			<div className="flex flex-col px-3 pt-2.5 pb-1 gap-1">
				<div className="flex items-center justify-between gap-1.5 w-full min-h-10">
					<div className="flex-1 min-w-0 block max-w-full rounded-lg border border-border-subtle border-solid p-1">
						<div className="flex flex-row items-center">
							<Skeleton
								height={34}
								width={34}
								circle
								className="shrink-0 mr-2"
							/>
							<div className="flex flex-col grow gap-0.5 min-w-0">
								<Skeleton height={13} width={80} />
								<Skeleton height={11} width={60} />
							</div>
						</div>
					</div>
					<Skeleton height={30} width={30} radius="md" className="shrink-0" />
				</div>

				<div className="flex flex-col gap-0.5 pt-0.5">
					<Skeleton height={32} radius="md" />
					<Skeleton height={32} radius="md" />
				</div>
			</div>

			<Divider />
		</nav>
	)
}
